import { Typography } from "@material-ui/core"
import * as Colors from "@material-ui/core/colors"
import { withStyles } from "@material-ui/core/styles"
import { updateItem } from "actions/items"
import {
  clearScreen,
  setScreenColor,
  setTemplate,
  updateScreen
} from "actions/screen"
import classnames from "classnames"
import PubnubController from "components/PubnubController"
import Template from "components/Template"
import { isEmpty } from "lodash"
import { publishSync } from "pubsub-js"
import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { CSSTransition } from "react-transition-group"
import { compose } from "recompose"
import {
  getManagerChannelName,
  getScreensChannelName,
  SCREEN_CONNECTED_ACTION
} from "types/pubnub"
import { ADMIN_EVENT } from "types/pubsub"
import { getEvent } from "../../actions/event"
import styles from "./styles"

const colors = [
  "red",
  "purple",
  "blue",
  "teal",
  "lightGreen",
  "yellow",
  "blueGrey"
]

export class Event extends Component {
  componentDidMount() {
    this.props
      .dispatch(getEvent(this.props.match.params.event_url))
      .then(() => {
        const screenChannelName = getScreensChannelName(
          this.props.event.auction_code
        )
        this.setState({
          screenChannelName
        })
      })
  }
  state = {
    screenChannelName: "",
    showScreenIdentifier: false,
    showTemplate: false
  }
  pubnub = React.createRef()
  eventPubnub = React.createRef()
  globalTimer = null
  handleMessage = message => {
    // console.log(message)
    const { action, data } = message
    if (this.hasOwnProperty(action)) {
      this[action](data)
    }
  }
  handleEventMessage = message => {
    // console.log(message)
    const { action, data } = message
    this.updateRedux(action, data)
    publishSync(`${ADMIN_EVENT}::${action}`, data)
  }
  updateRedux = (action, data) => {
    if (action === "highBid" || action === "removeBid") {
      this.props.dispatch(
        updateItem({
          item_id: data.item_id,
          high_bid: data.current_high_bid,
          high_bid_data: {
            high_bid_user_name: data.full_name
          }
        })
      )
    }
  }
  handleStatus = st => {
    if (st.category === "PNConnectedCategory") {
      const screenChannelName = getScreensChannelName(
        this.props.event.auction_code
      )
      let screenColor = colors[0]
      this.pubnub.current.pubnub.hereNow(
        {
          channels: [screenChannelName],
          includeUUIDs: true,
          includeState: true
        },
        (st, res) => {
          const screens = res.channels[screenChannelName].occupants.filter(
            occ => occ.state !== undefined && occ.state.isScreen === true
          )
          const takenColors = screens.map(screen => screen.state.color)
          const availableColors = colors.filter(
            color => takenColors.indexOf(color) === -1
          )
          screenColor = availableColors[0]
          this.pubnub.current.pubnub.setState({
            channels: [this.state.screenChannelName],
            state: {
              isScreen: true,
              color: screenColor
            }
          })
          this.props.dispatch(setScreenColor(screenColor))
          setTimeout(() => {
            this.pubnub.current.pubnub.publish({
              channel: getManagerChannelName(this.props.event.auction_code),
              message: {
                action: SCREEN_CONNECTED_ACTION,
                data: this.props.screen
              }
            })
          }, 50)
        }
      )
    }
  }
  rollCall = () => {
    this.pubnub.current.pubnub.publish({
      channel: getManagerChannelName(this.props.event.auction_code),
      message: {
        action: SCREEN_CONNECTED_ACTION,
        data: this.props.screen
      }
    })
  }
  identifyDisplays = () => {
    this.setState({
      showScreenIdentifier: true
    })
    setTimeout(() => {
      this.setState({
        showScreenIdentifier: false
      })
    }, 10000)
  }
  clearScreen = data => {
    if (data.id === this.props.screen.id) {
      this.setState({
        showTemplate: false
      })
      clearTimeout(this.globalTimer)
    }
  }
  updateScreen = data => {
    // console.log("updateScreen", data)
    if (data.id === this.props.screen.id) {
      this.props.dispatch(updateScreen(data))
    }
  }
  templateExited = () => {
    this.props.dispatch(clearScreen())
  }
  setTemplate = data => {
    if (data.id === this.props.screen.id) {
      this.props.dispatch(setTemplate(data.template)).then(() => {
        setTimeout(() => {
          this.setState({
            showTemplate: true
          })
        }, 50)
        this.globalTimer = setInterval(() => {
          // console.log("RELOAD DATA")
          publishSync("GLOBAL::RELOADDATA")
        }, 300000) // 5 minutes
      })
    }
  }
  eventGradientStyle = () => {
    let eventPrimary = this.props.event.event_color || "#ac1388"
    let eventSecondary = "#333"
    return {
      background: `linear-gradient(180deg, ${eventSecondary} 0%, ${eventPrimary} 100%)`
    }
  }
  render() {
    const { classes } = this.props
    return (
      <Fragment>
        {this.props.screen.color && (
          <div
            className={classnames(classes.screenIdentifier, {
              [classes.showScreenIdentifier]: this.state.showScreenIdentifier
            })}
            style={{
              borderColor: Colors[this.props.screen.color][500]
            }}
          />
        )}
        <CSSTransition
          in={!this.state.showTemplate}
          timeout={350}
          classNames="fade"
          unmountOnExit
        >
          <div className={classes.setupContent}>
            <div className={classes.top}>
              <div className={classes.cast}>
                <img
                  className={classes.castIcon}
                  src="//display.bidr.co/assets/images/cast-icon.svg"
                  alt="Ready to Cast"
                />
                <Typography
                  component="span"
                  variant="h2"
                  className={classes.setupContentTitle}
                >
                  Ready to Cast
                </Typography>
              </div>
              <Typography
                component="span"
                className={classes.setupContentInstructions}
              >
                Visit
                <Typography
                  component="strong"
                  variant="subtitle2"
                  className={classes.instructionsBold}
                >
                  https://manager.event.gives
                </Typography>
                to manage
              </Typography>
            </div>
            <div className={classes.bottom}>
              <div className={classes.nameWrapper}>
                <Typography component="span" className={classes.screenName}>
                  {this.props.screen.name}
                </Typography>
                {!this.props.event.digitalsign_image && (
                  <div className={classes.bidrLogo}>
                    <img
                      src="https://res.cloudinary.com/bidr/image/upload/v1717101684/WhiteNoTagline_nakbpt.png"
                      alt="Bidr"
                      style={{
                        height: "100%"
                      }}
                    />
                  </div>
                )}
              </div>
              <div className={classes.colorBars}>
                {this.props.screen.color && (
                  <Fragment>
                    <div
                      className={classes.bar}
                      style={{
                        backgroundColor: Colors[this.props.screen.color][500]
                      }}
                    />
                    <div
                      className={classes.bar}
                      style={{
                        backgroundColor: Colors[this.props.screen.color][300],
                        animationDelay: "0.1s"
                      }}
                    />
                    <div
                      className={classes.bar}
                      style={{
                        backgroundColor: Colors[this.props.screen.color][200],
                        animationDelay: "0.2s"
                      }}
                    />
                    <div
                      className={classes.bar}
                      style={{
                        animationDelay: "0.3s"
                      }}
                    />
                  </Fragment>
                )}
              </div>
              <div className={classes.screenId}>{this.props.screen.id}</div>
            </div>
          </div>
        </CSSTransition>
        <CSSTransition
          in={this.state.showTemplate}
          timeout={2000}
          classNames="fade"
          unmountOnExit
          onExited={this.templateExited}
        >
          <Template
            template={this.props.screen.template}
            event={this.props.event}
          />
        </CSSTransition>
        {this.state.screenChannelName && (
          <PubnubController
            channelName={this.state.screenChannelName}
            onMessage={this.handleMessage}
            onStatus={this.handleStatus}
            ref={this.pubnub}
            uuid={this.props.screen.id}
          />
        )}
        {!isEmpty(this.props.event) && (
          <PubnubController
            channelName={`display-event-${this.props.event.auction_code}`}
            onMessage={this.handleEventMessage}
            ref={this.eventPubnub}
          />
        )}
        {this.props.event.event_logo && (
          <aside
            className={classes.backgroundImageContainer}
            style={{ backgroundImage: `url(${this.props.event.event_logo})` }}
          >
            <div
              className={classes.backgroundImageGradient}
              style={this.eventGradientStyle()}
            />
          </aside>
        )}
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  event: state.event.event,
  screen: state.screen.screen
})

export default compose(connect(mapStateToProps), withStyles(styles))(Event)



// WEBPACK FOOTER //
// ./src/pages/Event/index.jsx